import type { BuildInfo } from '../../build/build-info';

declare const __SHYCUT_BUILD__: BuildInfo | undefined;

/** The build that is running (set by vite.config.ts); tests and tools without it see a local build. */
export const BUILD: BuildInfo = typeof __SHYCUT_BUILD__ !== 'undefined' ? __SHYCUT_BUILD__ : { commit: 'local', builtAt: new Date(0).toISOString() };
